import type { Msg } from '@halo/chat-sdk-react';
import { formatDuration } from '@halo/utils';
import { useMsgMediaTitle } from '../msg-media-call';

export interface MsgMediaHangUpContentProps {
  message: Msg;
  children?: (props: { typeDisplay: string; duration: string }) => React.ReactNode;
}

export const MsgMediaHangUpContent = memo(function MsgMediaHangUpContent({
  message,
  children,
}: MsgMediaHangUpContentProps) {
  const { type, call_started_at, created_at, now_time } = message.payload;

  const duration = useMemo(
    () => formatDuration(now_time - (call_started_at || created_at)),
    [now_time, call_started_at, created_at]
  );

  const { typeDisplay } = useMsgMediaTitle({ type });

  return <>{children?.({ typeDisplay, duration })}</>;
});
